<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content event-bg">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/5.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color padding">
      <h1 class="page-title white-color">Contact Us</h1>
      <ul>
        <li>
          <a class="active" href="index.html">Home</a>
        </li>
        <li>Contact Us</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Contact Section Start -->
  <div class="contact-page-section pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row rs-contact-box mb-90 md-mb-50">
        <div class="col-lg-4 col-md-12-4 lg-pl-0 sm-mb-30 md-mb-30">
          <div class="address-item">
            <div class="icon-part">
              <img src="assets/images/contact/icon/1.png" alt="Central Office Icon">
            </div>
            <div class="address-text">
              <span class="label">Central<br /> Office</span>
              <span class="des">
                Near RTC Bus Stand ,
                Anantapuramu-515001,
                AP.
              </span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 lg-pl-0 sm-mb-30 md-mb-30">
          <div class="address-item">
            <div class="icon-part">
              <img src="assets/images/contact/icon/1.png" alt="Regional Office Icon">
            </div>
            <div class="address-text">
              <span class="label">Regional Office</span>
              <span class="des">
                Sanapa Road,
                Alamuru Post,
                Rudrampeta Bypass,
                Anantapuramu-515001, AP.
              </span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 lg-pl-0 sm-mb-30">
          <div class="address-item">
            <div class="icon-part">
              <img src="assets/images/contact/icon/3.png" alt="">
            </div>
            <div class="address-text">
              <span class="label">Contact Us</span>
              <span class="des">
                T. Srinivasulu Reddy, SO – 8886630033
                Sri Sreekanth Reddy, MR – 8688810055
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-6 md-mb-30">
          <!-- Map Section Start -->
          <div class="contact-map3">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3492.6345768924857!2d77.6020918!3d14.685038799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb14ad9f8111341%3A0x926a830ae2e9511b!2sSRI%20BALAJI%20EDUCATIONAL%20SOCIETY!5e1!3m2!1sen!2sin!4v1773927592595!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
        <div class="col-lg-6 pl-60 md-pl-15">
          <div class="contact-comment-box">
            <div class="inner-part">
              <h2 class="title mb-mb-15">Get In Touch</h2>
              <p>If You Have Any Query, Please Contact Us</p>
            </div>
            <div id="form-messages"></div>
            <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-lg-6 mb-35 col-md-12">
                  <input type="text" class="form-control" placeholder="Enter First Name" formControlName="firstName">
                  <div *ngIf="isFieldValid('firstName')" class="alert alert-danger">
                    Enter a valid first name
                  </div>
                </div>
                <div class="col-lg-6 mb-35 col-md-12">
                  <input type="text" class="form-control" placeholder="Enter Last Name" formControlName="lastName">
                  <div *ngIf="isFieldValid('lastName')" class="alert alert-danger">
                    Enter a valid last name
                  </div>
                </div>
                <div class="col-lg-6 mb-35 col-md-12">
                  <input type="text" class="form-control" placeholder="Enter Valid Mail Address" formControlName="emailAddress">
                  <div *ngIf="isFieldValid('emailAddress')" class="alert alert-danger">
                    Enter Valid Email Address
                  </div>
                </div>
                <div class="col-lg-6 mb-35 col-md-12">
                  <input class="form-control" placeholder="Phone Number" formControlName="phoneNumber">
                  <div *ngIf="isFieldValid('phoneNumber')" class="alert alert-danger">
                    Enter a valid 10-digit number
                  </div>
                </div>
                <div class="col-lg-12 mb-50">
                  <textarea class="from-control" id="message" name="message" placeholder=" Message" formControlName="message"></textarea>
                </div>
              </div>
              
              <div class="form-group mb-0">
                <button
                  class="btn-send"
                  type="submit"
                  [disabled]="!contactUsForm.valid || isLoad"
                  [attr.aria-busy]="isLoad"
                >
                  <span *ngIf="isLoad" class="btn-spinner" aria-hidden="true"></span>
                  {{ isLoad ? 'Submitting...' : 'Submit' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Contact Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
